module.exports = __webpack_public_path__ + "static/media/gh1.1552e49c.png";